import React from "react";

function ProductMedicineInformation({
    formData,
    handleChange,
    config
}) {
    // ✅ GET MEDICINE FIELDS FROM CONFIG AS ARRAY
    const medicineFields = config?.fields?.medicine || [];
    
    // ✅ CHECK IF FIELD EXISTS IN ARRAY
    const showField = (fieldName) => medicineFields.includes(fieldName);
    
    // ✅ IF NO FIELDS DEFINED, SHOW NOTHING
    if (medicineFields.length === 0) {
        return null;
    }

    return (
        <div className="card mb-3">
            <div className="card-header">
                <h5>Medicine Information</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {/* Batch Number */}
                    {showField("batch") && (
                        <div className="col-md-4 mb-3">
                            <label>Batch Number</label>
                            <input
                                type="text"
                                className="form-control"
                                name="batch_no"
                                value={formData.batch_no || ""}
                                onChange={handleChange}
                            />
                        </div>
                    )}

                    {/* Manufacturing Date */}
                    {showField("manufacturing_date") && (
                        <div className="col-md-4 mb-3">
                            <label>Manufacturing Date</label>
                            <input
                                type="date"
                                className="form-control"
                                name="manufacturing_date"
                                value={formData.manufacturing_date || ""}
                                onChange={handleChange}
                            />
                        </div>
                    )}

                    {/* Expiry Date - Always show if medicine component is enabled */}
                    {showField("expiry") && (
                        <div className="col-md-4 mb-3">
                            <label>Expiry Date</label>
                            <input
                                type="date"
                                className="form-control"
                                name="expiry_date"
                                value={formData.expiry_date || ""}
                                onChange={handleChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ProductMedicineInformation;